import React from "react";
import { connect, mapProps, mapReadPretty } from "@formily/react";
import { Input as AntdInput, TextArea as AntdTextArea } from "antd-mobile";
import { isValid } from "@formily/shared";
import { InputProps } from "antd-mobile/es/components/input";
import { TextAreaProps } from "antd-mobile/es/components/text-area";

const PreviewText: React.FC<InputProps> = (props) => {
  return <>{props.value}</>;
};

type ComposedInput = React.FC<InputProps> & {
  TextArea?: React.FC<TextAreaProps>;
};

export const CustomInput: ComposedInput = connect(
  AntdInput,
  mapProps((props) => {
    return {
      value: isValid(props.value) ? props.value : "",
    };
  }),
  mapReadPretty(PreviewText)
);

CustomInput.TextArea = connect(
  AntdTextArea,
  mapProps((props) => {
    return {
      value: isValid(props.value) ? props.value : "",
    };
  }),
  // API - mapReadPretty: https://react.formilyjs.org/zh-CN/api/shared/map-read-pretty
  mapReadPretty(PreviewText)
);

export default CustomInput;
